import React from "react";
import DataTable from "../../../Components/Table";

function AutomatedBillSkeletonCard() {
  return (
    <article
      className="bills-page__automation-card bills-page__automation-card--skeleton card h-100 is-loading"
      aria-hidden="true"
    >
      <div className="bills-page__automation-header d-flex justify-content-between align-items-start gap-3">
        <div className="bills-page__automation-provider d-flex align-items-center gap-3">
          <div className="bills-page__automation-badge skeleton-block" />
          <div className="bills-page__automation-copy">
            <div className="skeleton-line skeleton-line--title" />
            <div className="skeleton-line skeleton-line--short" />
          </div>
        </div>
        <div className="bills-page__status-pill bills-page__status-pill--skeleton skeleton-pill" />
      </div>

      <dl className="bills-page__automation-fields mb-0">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="d-flex justify-content-between align-items-center gap-3"
          >
            <div className="skeleton-line skeleton-line--field-label" />
            <div className="skeleton-line skeleton-line--field-value" />
          </div>
        ))}
      </dl>
    </article>
  );
}

function buildSkeletonRows(count) {
  return Array.from({ length: count }).map((_, index) => ({
    id: `automated-skeleton-${index}`,
  }));
}

export default function AutomatedBillsSkeleton({ count = 3, viewMode = "grid" }) {
  if (viewMode === "list") {
    return (
      <div className="bills-page__automation-table" aria-hidden="true">
        <DataTable
          columns={[
            { header: "Provider", accessor: "providerName" },
            { header: "Phone Number", accessor: "mobileNumber" },
            { header: "Amount", accessor: "amount" },
            { header: "Frequency", accessor: "frequency" },
            { header: "Next Payment", accessor: "nextPaymentDate" },
            { header: "Status", accessor: "status" },
            { header: "Automated Payment", accessor: "toggle" },
            { header: "Actions", accessor: "actions" },
          ]}
          data={buildSkeletonRows(count)}
          loading
          rowKey="id"
        />
      </div>
    );
  }

  return (
    <div className="row g-3">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="col-12 col-md-6 col-xl-4">
          <AutomatedBillSkeletonCard />
        </div>
      ))}
    </div>
  );
}
